import {Component, ElementRef, DoCheck} from '@angular/core';


@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooter{
  year: any;
  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    var nativeElement: HTMLElement = this.el.nativeElement,
      parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
    this.year = new Date().getFullYear();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-footer/app-footer.component.ts